import moment from 'moment'

export default (keyParams = [], identifier = moment().valueOf()) => {
  return keyParams.concat(identifier).join('-')
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/create_timestamp_key.js
 **/